import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=3738d618&scoped=true"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"
import style0 from "./RichEditor.vue?vue&type=style&index=0&id=3738d618&prod&scoped=true&lang=css"
import style1 from "./RichEditor.vue?vue&type=style&index=1&id=3738d618&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738d618",
  null
  
)

export default component.exports